import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateDirective } from '@ngx-translate/core';
import { IconComponent, LoadingIndicatorComponent, OpenWindowDirective } from '@tdwb/core';
import { FplRestService } from '../services/fpl-rest.service';
import { FplDisclosure } from '../fpl.domain';

@Component({
  selector: 'td-wb-fpl-terms-and-conditions',
  templateUrl: './fpl-terms-and-conditions.component.html',
  styleUrls: ['./fpl-terms-and-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateDirective,
    LoadingIndicatorComponent,
    IconComponent,
    OpenWindowDirective
  ]
})
export class FplTermsAndConditionsComponent {
  fplDisclosureContent: SafeHtml;
  loading: boolean = true;

  constructor(
    private readonly fplRestService: FplRestService,
    private readonly sanitizer: DomSanitizer,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {
    this.fplRestService.getFplDisclosure()
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (data: FplDisclosure): void => {
          if (data?.fplDisclosure) {
            this.fplDisclosureContent = this.sanitizer.bypassSecurityTrustHtml(data.fplDisclosure);
          }
          this.loading = false;
          this.changeDetectorRef.markForCheck();
        },
        error: (): void => {
          this.loading = false;
          this.changeDetectorRef.markForCheck();
        }
      });
  }
}
